import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=a0470c16"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=a0470c16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports